<template lang="pug">
  .municipalities
    .table-choose-panel
      .toolbar.toolbar_margin-bottom.toolbar_no-padding
        .toolbar__line
          .semibold Подконтрольные операторы
          form(@submit.prevent.stop="startSearch()").search
            input.search__input(
              type="search"
              v-model="searchQ"
              placeholder=""
            )
    div
      e-table-inner(
        :visibleColumns="visibleColumns"
        :itemsEndpoint="endpointListForInnerTable"
        ref="innerTable"
        :showDeleteButton="false"
      )

</template>

<script>
import { tko } from '@/api/api-endpoints'

export default {
  name: 'municipalities-with-operators',
  props: {
    fields: Object,
  },
  data() {
    return {
      searchQ: '',
      operationType: null,
      showModal: false,
      checkedLen: 0,
      checked: [],
    }
  },
  computed: {
    visibleColumns() {
      return {
        name: { label: 'Наименование' },
        mo: { label: 'Муниципальное образование' },
        legal_address: { label: 'Местоположение' },
      }
    },
  },
  methods: {
    startSearch() {
      this.$refs.innerTable.updateTable()
    },
    updateDataInInnerTable() {
      this.$refs.innerTable.updateTable()
    },
    endpointListForInnerTable(ctx, query = { 'per-page': 10 }) {
      let route = { query }
      if (ctx.q) {
        route.query.q = ctx.q
      }
      if (ctx.paginateObj) {
        route.query = Object.assign(route.query, ctx.paginateObj)
      }
      if (ctx.currentSort) {
        route.query.sort = ctx.currentSort
      }

      route.query.regional_operator_id = this.fields.id

      if (this.searchQ) {
        route.query.q = this.searchQ
      } else {
        delete route.query.q
      }
      return route.query.regional_operator_id
        ? {
            url: tko.regionalWithOperators(route),
            fields: {
              name: {
                label: 'Муниципальное образование',
              },
            },
          }
        : { url: null }
    },
  },
}
</script>
